var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRenameGuest = function SvgRenameGuest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2m6 0a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2m6 0h2a2 2 0 0 1 2 2v6M7 5H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7m0 0v-2.675a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2V21h6Zm-1-9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.02 8.98h2.121l3.359-3.359a1.5 1.5 0 0 0-2.121-2.121l-3.36 3.359v2.121Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRenameGuest;